import { useMutation, useQuery } from "@tanstack/react-query";
import { fetch3, fetch4, fetch5 } from "../commonApis/commonApis";
const url = process.env.REACT_APP_BASE_URL;

interface ApiResponse {
  success: boolean;
  data: any;
  message?: string;
}

export const useGiftCreateMutation = () => {
  return useMutation({
    mutationFn: async (payload: any) => {
      const res: ApiResponse = await fetch4(`${url}/api/gift`, payload);
      if (!res.success) {
        throw new Error(res.message || "Failed to create gift rule");
      }
      return res.data;
    },
  });
};

export const useFetchGiftData = (
  page: number = 1,
  limit: number = 50,
  searchFor: string = ""
) => {
  return useQuery({
    queryKey: ["giftRuleData", page, limit, searchFor],
    queryFn: async () => {
      const res = await fetch3(
        `${url}/api/gift?page=${page}&limit=${limit}&searchFor=${searchFor}`,
        "get"
      );
      if (!res || !res.data) {
        return { gifts: [], total: 0 };
      }
      return res.data;
    },
    staleTime: 0,
    refetchOnMount: true,
  });
};

export const useUpdateGiftStatusMutation = () => {
  return useMutation({
    mutationFn: async ({ id, status }: { id: string; status: string }) => {
      const res: ApiResponse = await fetch5(
        `${url}/api/gift/status/${id}`,
        "PATCH",
        { status }
      );
      if (!res.success) {
        throw new Error(res.message || "Failed to update gift rule status");
      }
      return res.data;
    },
  });
};

export const useDeleteGiftMutation = () => {
  return useMutation({
    mutationFn: async (id: string) => {
      const res: ApiResponse = await fetch5(
        `${url}/api/gift/${id}`,
        "DELETE",
        {}
      );
      if (!res.success) {
        throw new Error(res.message || "Failed to delete gift rule");
      }
      return res.data;
    },
  });
};

export const useUpdateGiftMutation = () => {
  return useMutation({
    mutationFn: async ({ id, payload }: { id: string; payload: any }) => {
      const res: ApiResponse = await fetch5(
        `${url}/api/gift/${id}`,
        "PUT",
        payload
      );
      if (!res.success) {
        throw new Error(res.message || "Failed to update gift rule");
      }
      return res.data;
    },
  });
};
